import { StudyStoreState } from '@/enums/study-store-state';
import { SessionCreatedEvent } from '@studyportals/student-interfaces';
import globals from '../../utils/globals';
import { store } from '../store';
import { ISubscriber } from '@studyportals/event-aggregation-service-interface';

export class LoginStatusCheckerPlugin
implements ISubscriber<SessionCreatedEvent>
{
	public async notify(): Promise<void> {
		await this.handleActiveSession();
	}

	public async initiate(): Promise<void> {
		const session = await globals.sessionService.getSession();

		if (!session) {
			store.actions.setLoggedInState(false);
			globals.eventAggregationService?.subscribeTo(
				SessionCreatedEvent.EventType,
				this,
				true,
			);
			return;
		}

		await this.handleActiveSession();
	}

	private async handleActiveSession(): Promise<void> {
		store.actions.setLoggedInState(true);
		await this.startFitCalculation();
	}

	private async startFitCalculation(): Promise<void> {
		store.actions.convertStudyStoreState({
			from: StudyStoreState.READY,
			to: StudyStoreState.PENDING,
		});

		await store.actions.calculateFit();
	}
}
